export const PDF_DATA_URL_PREFIX = "data:application/pdf;base64,";
export const PDF_CONTENT_MISSING_ERROR = "PDF_CONTENT_MISSING";

export const buildPdfDataUrl = (base64Content) => {
  const normalizedContent = typeof base64Content === "string"
    ? base64Content.trim()
    : "";

  if (!normalizedContent || normalizedContent.toLowerCase() === "null") {
    const error = new Error("El servicio no devolvió el contenido del documento PDF.");
    error.code = PDF_CONTENT_MISSING_ERROR;
    throw error;
  }

  return normalizedContent.startsWith(PDF_DATA_URL_PREFIX)
    ? normalizedContent
    : `${PDF_DATA_URL_PREFIX}${normalizedContent}`;
};

export const hasPdfDocument = (documentUrl) =>
  typeof documentUrl === "string" &&
  documentUrl.startsWith(PDF_DATA_URL_PREFIX) &&
  documentUrl.length > PDF_DATA_URL_PREFIX.length;
